module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-20fd1704ea223900efa9fd4e869efb08.woff2";